(function() {
    var ContactTypeSelector = function($el) {
        this.$el = $el
        this.$details = this.$el.find('.contact-details')
        this.$radio = this.$el.find('input[name=invoiceable_type]')

        this.$radio.on('change', this.toggleDetails.bind(this))

        this.$radio.trigger('change')
    
        return this
    }

    ContactTypeSelector.prototype.toggleDetails = function () {
        var event = jQuery.Event('contact.change');

        event.isContactable = this.isTypeContactable();

        if (event.isContactable) {
            this.$details.fadeIn()
        } else {
            this.$details.hide()
        }

        this.$el.trigger(event)
    }

    ContactTypeSelector.prototype.isTypeContactable = function () {
        return this.$radio.filter(':checked').val() == 'new'
    }
    
    $('.contact-type-selector').each(function () {
        new ContactTypeSelector($(this))
    })
})()
